import 'ol/ol.css'
import { View } from 'ol'
import { map, topoButton } from './modules/map.js'
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { Custom_Buttons } from './modules/Custom_Buttons.js'
import { fetchForecast, fetchForecastMeta, productConfig, WMS_MS_TO_KT } from 'wms-forecast-client';

// Exposer sur window pour les scripts legacy (toutou_utils_imeteo.js)
window.wms_fetchForecast     = fetchForecast;
window.wms_fetchForecastMeta = fetchForecastMeta;
window.wms_productConfig     = productConfig;
window.WMS_MS_TO_KT          = WMS_MS_TO_KT;

export const Get_Data = window.Get_Data;
export const Set_Action = window.Set_Action;
export const Get_Info = window.Get_Info;
window.pointsData = {};

export var buttons;
try {
  buttons = new Custom_Buttons('control_canvas');
  window.buttons = buttons;
} catch (e) {
  console.error(e.message);
}

let ctx_control, ctx_graph;   // contexte 2D des canvas
let rect_control, rect_graph;

export function main_initialize() {
  ctx_control = document.getElementById('control_canvas').getContext('2d');
  ctx_graph = document.getElementById('graph_canvas').getContext('2d');
  window.ctx_graph = ctx_graph;
  // Supprime les marges et paddings du body et de tous les éléments
  document.body.style.margin = '0';
  document.body.style.padding = '0';
  document.body.style.boxSizing = 'border-box';
  ['control', 'graph', 'map_canvas'].forEach(id => {
    const el = document.getElementById(id);
    if (el) {
      el.style.margin = '0';
      el.style.padding = '0';
      el.style.border = 'none';
      el.style.boxSizing = 'border-box';
    }
  });
  const rect = document.getElementById('graph_canvas').getBoundingClientRect();
  console.log('graph_canvas, size : width = ', rect.width, ', height = ',rect.height);
  
  //initOpenLayers();   // ta configuration OL habituelle
  updateLayout();     // place les éléments + mise à l’échelle Hi-DPI
}

/**********************************************************
 *  MISE EN PAGE RÉACTIVE
 **********************************************************/
function showLoadingIndicator() {
  const el = document.getElementById('loading-indicator');
  if (el) el.style.display = 'block';
}

function hideLoadingIndicator() {
  const el = document.getElementById('loading-indicator');
  if (el) el.style.display = 'none';
}

export function updateLayout(shouldGetData = true) {
  const w  = window.innerWidth;
  const h  = window.innerHeight;
  const r  = w / h;
  const ctl = document.getElementById('control');
  const grp = document.getElementById('graph');
  const mapDiv = document.getElementById('map_canvas');

  //console.log("buttons.numButtonRows=",buttons.numButtonRows);
  
  [ctl, grp, mapDiv].forEach(el => el.style.position = "absolute");

  if (r > 2.0) { // --- Mode paysage
    const ctlH = h * 0.09*buttons.numButtonRows; // 15% en haut pour les contrôles
    const contentH = h - ctlH;

    Object.assign(ctl.style, {
      left: "0px", top: "0px", width: `${w}px`, height: `${ctlH}px`
    });
    
    const width_1 = w * 3./4;
    Object.assign(grp.style, {
      left: "0px"         , top: `${ctlH}px`, width: `${width_1}px`   , height: `${contentH}px`
    });
    Object.assign(mapDiv.style, {
      left: `${width_1}px`, top: `${ctlH}px`, width: `${w-width_1}px`, height: `${contentH}px`
    });

  } else { // --- Portrait : 3 lignes comme avant
    const ratio_1 = 1./20.*buttons.numButtonRows;
    const ratio_2 = .67;
    const ratio_3 = 1.-(ratio_1+ratio_2);
    const height_1= h*ratio_1;
    const height_2= h*ratio_2;
    const height_3= h*ratio_3;

    Object.assign(ctl.style   , { left:0, top:`0px`,            width:`${w}px`, height:`${height_1}px`});
    Object.assign(grp.style   , { left:0, top:`${height_1}px`,  width:`${w}px`, height:`${height_2}px`});
    Object.assign(mapDiv.style, { left:0, top:`${height_1+height_2}px`, width:`${w}px`, height:`${height_3}px`});
  }
  
  ctx_control = document.getElementById('control_canvas').getContext('2d');
  rect_control = resizeHiDPICanvas(ctx_control);
  rect_graph = resizeHiDPICanvas(ctx_graph);
  //console.log('updateLayout rect_graph.width=',rect_graph.width)
  //console.log('ctx_graph.canvas.getBoundingClientRect().width=',ctx_graph.canvas.getBoundingClientRect().width);
  
  window.gxsize=rect_graph.width;
  window.gysize=rect_graph.height;
  
  window.gfonte_max=3;
  window.gfonte=0;
  if(window.gxsize < 1000){window.gfonte=2;}
  if(window.gxsize <  800){window.gfonte=1;}
      
  const controlDiv = document.getElementById('control');
  // Supprimer l'ancien canvas s'il existe
  controlDiv.innerHTML = ''; // Nettoyage
  const canvas = document.createElement('canvas');
  canvas.id = 'control_canvas';
  canvas.width = controlDiv.clientWidth;
  canvas.height = controlDiv.clientHeight;
  controlDiv.appendChild(canvas);
  ctx_control=canvas.getContext('2d');
  buttons.set_buttons();
  if (shouldGetData) {
    showLoadingIndicator();
    Get_Data(window.product)
      .finally(() => {
	hideLoadingIndicator();
      });
  }
  //drawGraph()
  // --- 📍 Sauvegarde des coordonnées de graph_canvas
  const rect = document.getElementById('graph_canvas').getBoundingClientRect();
  window.graphCanvasDim = {
    left:        rect.left + window.scrollX,
    right:       rect.right + window.scrollX,
    top:         rect.top + window.scrollY,
    bottom:      rect.bottom + window.scrollY,
  };
  //console.log("📐 graphCanvasDim :", window.graphCanvasDIM);
}

/**********************************************************
 *  CANVAS Hi-DPI
 **********************************************************/
function resizeHiDPICanvas(ctx) {
  const canvas = ctx.canvas;
  const rect   = canvas.getBoundingClientRect();     // taille CSS visible
  const ratio  = window.devicePixelRatio || 1;       // 1 sur laptop, 2 sur iPhone, etc.

  // Ne change que si c’est nécessaire (évite le clignotement)
  const wantW = Math.round(rect.width  * ratio);
  const wantH = Math.round(rect.height * ratio);
  if (canvas.width !== wantW || canvas.height !== wantH) {
    canvas.width  = wantW;
    canvas.height = wantH;
    ctx.scale(ratio, ratio);                    // remet l’échelle logique
  }
  return canvas.getBoundingClientRect();
}

/**********************************************************
 *  DESSINER LE GRAPHIQUE 
 **********************************************************/
function drawGraph() {
  const visibleWidth = ctx_graph.canvas.getBoundingClientRect().width;
  const visibleHeight = ctx_graph.canvas.getBoundingClientRect().height;
  //console.log("visibleWidth=",visibleWidth,", visibleHeight=",visibleHeight);
  // Par exemple : la police fera 5% de la largeur visible
  const fontSize = visibleWidth * 0.05; // 5% de la largeur
  // Applique dynamiquement la taille de police
  ctx_graph.font = `${fontSize}px Arial`;
  // Dessin simple de test : texte + ligne
  ctx_graph.fillStyle = '#eee';
  ctx_graph.fillRect(0,0,visibleWidth,visibleHeight);
  ctx_graph.fillStyle = 'black';
  ctx_graph.fillText('Hello Retina!', visibleWidth/2,visibleHeight/2);
  ctx_graph.beginPath();
  ctx_graph.moveTo(0, 0);
  ctx_graph.lineTo(visibleWidth,visibleHeight);
  ctx_graph.stroke();
}

window.addEventListener('DOMContentLoaded', main_initialize);

// Cette façon d'jouter le Listerner permet de le suspendre quand l'utilisateur
// déclanche l'animation en gissant son doit de <-->.
let resizeTimeout;

// Définition de la fonction que l'on pourra attacher/détacher
function handleResize() {
  updateLayout(false); // ajuste la disposition mais ne charge pas les données
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    updateLayout(true); // recharge les données à la fin
  }, 200);
}

// On expose cette fonction au code legacy
window.handleResize = handleResize;

// Attache initial
window.addEventListener('resize', handleResize);

// Fonctions de suspension et reprise
function suspendResizeListener() {
  clearTimeout(resizeTimeout);  // annule aussi tout reload planifié
  window.removeEventListener('resize', handleResize);
}

function resumeResizeListener() {
  window.addEventListener('resize', handleResize);
}

// On les expose aussi au code legacy
window.suspendResizeListener = suspendResizeListener;
window.resumeResizeListener = resumeResizeListener;

window.updateLayout = updateLayout;
window.APP_VERSION = process.env.GIT_VERSION || 'dev';

console.log("✅ main.js chargé");
